import React, { useState, useContext } from 'react';
import '../styles/CreateParty.css';
import AuthContext, { CacheContext } from '../contexts/index';
import Party from '../entities/party';
import { useNavigate } from 'react-router-dom';
import { createParty } from '../apiCalls/partyAPI';


function UpdateParty() {
    const visible = { visibility: 'visible' };
    const hidden = { visibility: 'hidden' };
    const { user, setUser } = useContext(AuthContext);
    const { cachedParties, setCachedParties } = useContext(CacheContext);
    const [modalShow, setModalShow] = useState(hidden);
    const navigate = useNavigate();
    const [partyName, setPartName] = useState();
    const [guestList, setGuestList] = useState([]);
    const [guest, setGuest] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();
        setModalShow(visible);
        createParty(new Party(null, user.email, partyName, guestList), user.credential)
            .then(party => {
                let updatedUser = user;
                updatedUser.partyIds = [...user.partyIds, party.id];
                setUser(updatedUser);
                setCachedParties([...cachedParties, party]);
            })
            .then(() => setModalShow(hidden))
            .finally(() => navigate('/'))
            .catch(err => console.log(err
            ));
    }

    const addGuest = () => {
        setGuestList([...guestList, guest]);
        setGuest("");
    }

    const removeGuest = (guest) => {
        setGuestList(guestList.filter(g => g !== guest));
    }

    return (
        <>
            <span className="loader" style={modalShow}></span>
            <div className="container">
                <h1>Create A Party!!</h1>
                <div className='row'>
                    <div className="col-md-6">
                        <form id="createPartyForm" onSubmit={handleSubmit}>

                            <div className="form-group" >
                                <label htmlFor="">Party Name</label>
                                <input type="text" name="partyName" className="form-control" placeholder="Enter party name..." data-testid="partyName" onChange={(e) => setPartName(e.target.value)} />
                            </div>
                            <div className="guest-list-card">
                                <label htmlFor="guestList">Add Emails to Guest List</label>
                                <div className="guest-input-group">
                                    <input
                                        type="text"
                                        name="guestListTextbox"
                                        className="form-control"
                                        placeholder='myguest@email.com'
                                        value={guest}
                                        id={`guestListTextbox`}
                                        data-testid={`guestListTextbox`}
                                        onChange={(e) => setGuest(e.target.value.toLowerCase())}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => addGuest()}
                                        disabled={!guest}
                                        className="add-guest-btn"
                                    >
                                        +
                                    </button>
                                </div>
                                <div className="guest-note">
                                    You can always add or remove guests later...
                                </div>
                                {
                                    guestList.length > 0 && (
                                        <div style={{ marginBottom: '1rem', maxHeight: '200px', overflowY: 'auto' }}>
                                            {guestList.map((guestItem, i) => (
                                                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem', padding: '0.5rem', backgroundColor: '#ffffff', borderRadius: '4px', color: '#1a1a1a' }}>
                                                    <span>{guestItem}</span>
                                                    <button 
                                                        type="button"
                                                        onClick={() => removeGuest(guestItem)} 
                                                        className="btn red"
                                                        style={{ padding: '0.25rem 0.75rem', marginLeft: '0.5rem' }}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                }
                                <div className="save-button-container">
                                    <button type="submit" disabled={!partyName} className="green" data-testid="saveButton">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>

    );
}

export default UpdateParty;